export const AVAILABLE_SELECTED_OPERATIONS_KEYS = ["bore", "cut_to", "frez", "hem", "paz", "trough"];
export const AVAILABLE_SELECTED_FILTER_OPERATIONS_KEYS = ["bore", "cut_to", "frez", "hem", "paz", "trough", "srez"];
